// Configuración de entorno
const getEnvironmentConfig = () => {
  // Detectar si estamos en producción
  const isProduction = process.env.NODE_ENV === 'production';

  const productionDomain = process.env.REACT_APP_PRODUCTION_URL || 'https://bitacoras.moreseg.com';
  const companyName = process.env.REACT_APP_COMPANY_NAME || 'Moreseg Cia. Ltda.';
  const loginButtonColor = process.env.REACT_APP_LOGIN_BUTTON_COLOR || '#DC2626'; // Tailwind red-600
  const logoFilename = process.env.REACT_APP_LOGO_FILENAME || 'logo-empresa.png';
  const puntoChar = process.env.REACT_APP_CHAR || '';
  const normalizeDomain = (domain) => domain.replace(/\/$/, '');
  
  const config = {
    isProduction,
    apiUrl: isProduction 
      ? `${normalizeDomain(productionDomain)}/api`   // Usar dominio público con /api
      : 'http://localhost:3004/api',    // Desarrollo: backend en 3004
    domain: isProduction 
      ? normalizeDomain(productionDomain) 
      : 'http://localhost:3005',        // Desarrollo: frontend en 3005
    companyName,
    loginButtonColor,
    productionDomain: normalizeDomain(productionDomain),
    logoPath: `/${logoFilename.replace(/^\//, '')}`,
    puntoChar
  };
  
  // Debug: Mostrar información de conexión en consola
  console.log('🔧 Configuración de entorno:');
  console.log('  - Entorno:', isProduction ? 'PRODUCCIÓN' : 'DESARROLLO');
  console.log('  - API URL:', config.apiUrl);
  console.log('  - Dominio:', config.domain);
  console.log('  - Empresa:', config.companyName);
  console.log('  - Color botón login:', config.loginButtonColor);
  console.log('  - Logo:', config.logoPath);
  console.log('  - Hostname actual:', window.location.hostname);
  console.log('  - Protocolo actual:', window.location.protocol);
  
  return config;
};

export default getEnvironmentConfig();
